export default () => ({
  calendarList: [],
  colors: {
    1: 'red',
    2: 'blue',
    3: 'grey',
  },
  needShowProposalModal: false,
  currentCalendarOptions: {},
  showCalendarDragModal: false,
  dragCalendarState: {
    draggedEvent: {},
    divSecond: 0,
    error: ''
  },
  mstProcessingEvents: [],
})
